<template>
  <div>
    <AppLoader v-if="isLoading" class="text-center" small />
    <b-container fluid id="my-container">
      <b-navbar toggleable="lg" type="dark" variant="light">
        <b-navbar-brand href="#" class="text-dark">
          <strong>Search Results for Control Group</strong>
          <!-- <b-button variant="primary" ref="button" @click.prevent="popoverShow = !popoverShow">Popover</b-button> -->
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button variant="outline-info" size="sm" @click="reloadTable">
                <font-awesome-icon icon="sync" />
              </b-button>
              <b-form-group
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <b-table
        class="mx-1"
        bordered
        sticky-header="calc(100vh - 200px)"
        ref="table"
        id="my-table"
        :busy.sync="isLoading"
        :items="getControlGroupSearchPopulationTableData"
        :fields="tableFields"
        :filter="filter"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        responsive="sm"
      >
        <template v-slot:cell(website)="data">
          <!-- negative media -->
          Total: {{ getNegativeMediaKeyWordsTotalCount(data) }}
          <br />
          <div class="text-nowrap">
            <p style="white-space: pre-line;">{{ getNegativeMediaKeyWordsTotalByCategoryCount(data) }}</p>
          </div>

          <!-- Filtered: {{ data.item.negativeMediaKeywordTotalFiltered }}
          <br />
          <div class="text-nowrap">
            <p v-html="getNegativeMediaKeyWordsTotalByCategoryCountFiltered(data)"></p>
          </div>-->
        </template>
        <template v-slot:cell(registration_number)="data">
          <!-- future risks media -->
          Total: {{ getFutureRisksKeyWordsTotalCount(data) }}
          <br />
          <div class="text-nowrap">
            <p style="white-space: pre-line;">{{ getFutureRisksKeyWordsTotalByCategoryCount(data) }}</p>
          </div>
        </template>
        <template v-slot:cell(completed)="data">
         <p><span>Started:</span> <span>{{data.item.started}}</span></p>
          <p><span>Compeleted:</span> <span>{{data.item.completed}}</span></p>
        </template>
        <template v-slot:cell(sanctions)="data">
          <b-badge variant="success" v-if="checkSanctions(data) == 0">No Alert Found</b-badge>
          <b-badge
            variant="danger"
            v-if="checkSanctions(data) > 0"
          >Alert Found {{checkSanctions(data)}}</b-badge>
        </template>
        <template v-slot:cell(1)="data">
          <b-badge variant="warning">Very Common</b-badge>
        </template>
        <template v-slot:cell(public_listed_company)="data">
          <b-badge variant="success" v-if="checkPublicListedCompany(data) == 0">No Alert Found</b-badge>
          <b-badge
            variant="danger"
            v-if="checkPublicListedCompany(data) > 0"
          >Alert Found {{checkPublicListedCompany(data)}}</b-badge>
        </template>
        <template v-slot:cell(created_at)="data">
          <div class="text-nowrap">{{ age(data.item.created_at) }}</div>
        </template>
        <template v-slot:cell(comp_name_eng)="data">
          <div class="text-nowrap">{{ data.item.comp_name_eng }}</div>
        </template>
        <template v-slot:cell(status)="data">
          <span v-if="data.item.status==0">
            <b-badge variant="warning">Processing</b-badge>&nbsp;
            <b-spinner variant="warning" type="grow" label="Spinning"></b-spinner>
          </span>
          <span v-if="data.item.status==1">
            <b-badge
              :id="data.item.id.toString()+'status'"
              variant="success"
              @click="onOpenStatus(data)"
            >Completed</b-badge>&nbsp;
          </span>
        </template>
        <template v-slot:cell(actions)="data">
          <b-button
            size="sm"
            variant="outline-primary"
            :to="'/pri-search/control-group/'+data.item.id"
          >
            <font-awesome-icon icon="eye"></font-awesome-icon>
          </b-button>
        </template>
      </b-table>
      <b-row>
        <b-col cols="2">
          <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
        </b-col>
        <b-col>
          <b-pagination
            class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
            aria-controls="my-table"
          ></b-pagination>
        </b-col>
      </b-row>
      <!-- <b-popover
        placement="bottom"
        container="#body"
        :target="popoverId+'website'"
        ref="popoverWebsite"
        xl
        size="xl"
      >
        <template v-slot:title>
          <b-button @click="onCloseWebsite" class="close" aria-label="Close">
            <span class="d-inline-block" aria-hidden="true">&times;</span>
          </b-button>Negative Media
        </template>
        <div>
          <div v-if="finalArray.length">
            <div v-for="(media,index) in negativeMediaCategories" :key="index">
              <p>{{media.title}}</p>
              <div v-for="(val,index) in finalArray" :key="index">
                <b-badge variant="success">{{val.keyword}}</b-badge>
                <b-badge :variant="val.count <= 0 ? 'danger' : 'warning'" class="mx-2">{{val.count}}</b-badge>
              </div>
            </div>
          </div>
          <p>keyword Matches Total: {{negativeMediaKeywordMatchesTotal}}</p>
        </div>
      </b-popover>-->
      <!-- <b-popover :target="popoverId+'registration-number'" ref="popoverRegistrationNumber">
        <template v-slot:title>
          <b-button @click="onCloseRegistrationNumber" class="close" aria-label="Close">
            <span class="d-inline-block" aria-hidden="true">&times;</span>
          </b-button>Interactive Content
        </template>
        <div>
          <p>Future Risks Popover</p>
        </div>
      </b-popover>-->
      <!-- <b-popover :target="popoverId+'1'" ref="popover1">
        <template v-slot:title>
          <b-button @click="onClose1" class="close" aria-label="Close">
            <span class="d-inline-block" aria-hidden="true">&times;</span>
          </b-button>Interactive Content
        </template>
        <div>
          <p>OC Popover</p>
        </div>
      </b-popover>-->
      <!-- <b-popover :target="popoverId+'2'" ref="popover2">
        <template v-slot:title>
          <b-button @click="onClose2" class="close" aria-label="Close">
            <span class="d-inline-block" aria-hidden="true">&times;</span>
          </b-button>Interactive Content
        </template>
        <div>
          <p>PLC Popover</p>
        </div>
      </b-popover>-->
      <b-popover :target="popoverId+'status'" ref="popoverStatus">
        <template v-slot:title>
          <b-button @click="onCloseStatus" class="close" aria-label="Close">
            <span class="d-inline-block" aria-hidden="true">&times;</span>
          </b-button>Interactive Content
        </template>
        <div>
          <p>Status Popover</p>
        </div>
      </b-popover>
    </b-container>
  </div>
</template>

<script>
import { HTTP } from "../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
import AppLoader from "../components/Loader/Loader";
import _ from "lodash";

export default {
  name: "PriSearchesControlGroupDetailListContainer",
  components: {
    AppLoader,
  },
  data() {
    return {
      popoverShow: false,
      input1: "",
      input1state: null,
      isLoading: false,
      filter: null,
      perPage: 50,
      totalRows: 0,
      currentPage: 1,
      sortBy: "status",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 100],
      tableFields: [
        {
          key: "created_at",
          label: "Age",
          sortable: true,
        },
        // {
        //   key: "third_party_id",
        //   label: "ID",
        //   sortable: true,
        // },
       {
          key: "completed",
          label: "Queue",
          sortable: false,
        },
        {
          key: "comp_name_eng",
          label: "Subject",
          sortable: true,
        },
        // {
        //   key: "country",
        //   label: "Country",
        //   sortable: true,
        // },
        {
          key: "website",
          label: "Negative Media",
          sortable: false,
        },
        {
          key: "registration_number",
          label: "Future Risks",
          sortable: false,
        },
        // {
        //   key: "1",
        //   label: "OC",
        //   sortable: false,
        // },
        // {
        //   key: "public_listed_company",
        //   label: "PLC",
        //   sortable: false,
        // },
        // {
        //   key: "sanctions",
        //   label: "S&E",
        //   sortable: false
        // },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "actions",
          label: "Action",
          sortable: false,
        },
      ],
      tableData: [],
      input1Return: "",
      popoverId: "1",
      //popover for negative mrdia
      negativeMediaCategories: [],
      negativeMediaKeywordMatchesTotal: 0,
      negativeMediaSearchKeywordCount: 0,
      sortedArrays: [],
      finalArray: [],
      showNegativeDetails: false,
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  watch: {
    input1(val) {
      if (val) {
        this.input1state = true;
      }
    },
  },
  mounted() {},
  methods: {
    age(value) {
      let localeData = moment.updateLocale("en", {
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "hello, a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years",
        },
      });
      return moment.utc(value).fromNow();
      
    },
    onOpenStatus(data) {
      this.popoverId = null;
      let itemId = data.item.id.toString();
      this.popoverId = itemId;
      this.$refs.popoverStatus.$emit("open");
    },

    onCloseStatus() {
      this.$refs.popoverStatus.$emit("close");
    },

    // onOpenRegistrationNumber(data) {
    //   this.popoverId = null;
    //   let itemId = data.item.id.toString();
    //   this.popoverId = itemId;
    //   this.$refs.popoverRegistrationNumber.$emit("open");
    // },

    // onCloseRegistrationNumber() {
    //   this.$refs.popoverRegistrationNumber.$emit("close");
    // },

    // onOpen2(data) {
    //   this.popoverId = null;
    //   let itemId = data.item.id.toString();
    //   this.popoverId = itemId;
    //   this.$refs.popover2.$emit("open");
    // },

    // onClose2() {
    //   this.$refs.popover2.$emit("close");
    // },

    // onOpen1(data) {
    //   this.popoverId = null;
    //   let itemId = data.item.id.toString();
    //   this.popoverId = itemId;
    //   this.$refs.popover1.$emit("open");
    // },

    // onClose1() {
    //   this.$refs.popover1.$emit("close");
    // },

    // getNegativeData(data) {
    //    // console.log("Asas")
    //   let negativeData = JSON.parse(data.item.data);
    //   return negativeData;
    // },

    // getKeywords(data) {
    //   // let negativeData = JSON.parse(data.item.data);
    //   let array = [];
    //   let aa = {};
    //   // // console.log("getKeywords", data)

    //   data.results.map(media => {
    //     if (
    //       media.analysis &&
    //       media.analysis.searchKeywordCount &&
    //       media.analysis.searchKeywordCount.length > 0
    //     ) {
    //       media.analysis.searchKeywordCount.filter(keys => {
    //         array.push(keys);
    //       });
    //     }

    //     let getUique = _.uniqWith(array, _.isEqual);
    //     this.sortedArrays = getUique;
    //     // // console.log("negativeMedia", getUique);
    //   });

    //   // let getUique = _.uniqWith(array, _.isEqual);
    //   // getUique.map(searches => {
    //   // if (searches && searches.count && searches.keyword) {
    //   // aa = {
    //   // count: searches.count,
    //   // keyword: searches.keyword
    //   // };
    //   // // console.log("aa", aa);

    //   // }
    //   // });
    //   // _.uniqBy()
    //   // return _.uniqWith(data, _.isEqual);
    // },
    getNegativeMediaKeyWordsTotalCount(value) {
      let keywordCountValue = JSON.parse(value.item.negativeMediaKeywordTotal);
      if (keywordCountValue) {
        let totalCount = keywordCountValue;
        return totalCount;
      } else {
        return 0;
      }
    },
    getNegativeMediaKeyWordsTotalCountFiltered(value) {
      let keywordCountValue = JSON.parse(
        value.item.negativeMediaKeywordTotalFiltered
      );
      if (keywordCountValue) {
        let totalCount = keywordCountValue;
        return totalCount;
      } else {
        return 0;
      }
    },

    getFutureRisksKeyWordsTotalCount(value) {
      let keywordCountValue = JSON.parse(value.item.futureRisksKeywordTotal);
      if (keywordCountValue) {
        let totalCount = keywordCountValue;
        return totalCount;
      } else {
        return 0;
      }
    },

    getNegativeMediaKeyWordsTotalByCategoryCount(value) {
      let keywordCountValue = JSON.parse(
        value.item.negativeMediaKeyTotalByCategory
      );
      if (keywordCountValue) {
        return keywordCountValue
          .map((category) => category.title + " : " + category.value)
          .join("\n");
      } else {
        return 0;
      }
    },

    getNegativeMediaKeyWordsTotalByCategoryCountFiltered(value) {
      let keywordCountValue = JSON.parse(
        value.item.negativeMediaKeyTotalByCategoryFiltered
      );
      if (keywordCountValue) {
        return keywordCountValue
          .map((category) => category.title + " : " + category.value)
          .join("\n");
      } else {
        return 0;
      }
    },

    getFutureRisksKeyWordsTotalByCategoryCount(value) {
      let keywordCountValue = JSON.parse(
        value.item.futureRisksKeyTotalByCategory
      );
      if (keywordCountValue) {
        return keywordCountValue
          .map((category) => category.title + " : " + category.value)
          .join("\n");
      } else {
        return 0;
      }
    },
    checkSanctions(data) {
      return 0;
      // let value =  data.item.sanctions  ?  JSON.parse(data.item.sanctions) : null;
      // let sanctionsData = value;
      // if (sanctionsData.length == 0) {
      //   return 0;
      // }
      // if (sanctionsData.length > 0) {
      //   return sanctionsData.length;
      // }
    },

    checkPublicListedCompany(data) {
      let value = JSON.parse(data.item.publicListedCompanies);
      let publicListedCompaniesData = value;
      let companiesData = [];
      if (publicListedCompaniesData != null) {
        companiesData = publicListedCompaniesData.companies
          ? publicListedCompaniesData.companies
          : [];
        if (companiesData.length == 0) {
          return 0;
        }
        if (companiesData.length > 0) {
          return companiesData.length;
        }
      } else {
        return "";
      }
    },
    // onOpenWebsite(data) {
    //   let negativeData = JSON.parse(data.item.data);
    //   this.negativeMediaCategories = negativeData.negativeMedia;
    //   let keywordMatchesTotal = 0;
    //   this.negativeMediaKeywordMatchesTotal = 0;
    //   let tempArray = [],
    //     keywordsArray = [],
    //     finalArray = [];
    //   // this.showNegativeDetails = !this.showNegativeDetails;

    //   // // console.log("onOpenWebsite", negativeData)
    //   negativeData.negativeMedia.map(media => {
    //     media.results.map(result => {
    //       if (result.analysis.keywordMatchesTotal) {
    //         keywordMatchesTotal += result.analysis.keywordMatchesTotal;
    //         if (
    //           result.analysis.searchKeywordCount &&
    //           result.analysis.searchKeywordCount.length
    //         )
    //           result.analysis.searchKeywordCount.map(search => {
    //             // // console.log("seadcx", search)
    //             keywordsArray.push(search.keyword);
    //             tempArray.push({
    //               count: search.count,
    //               keyword: search.keyword
    //             });
    //           });
    //       }
    //     });
    //   });

    //   // // console.log("tempArray", tempArray)
    //   // // console.log("keywordsArray", _.uniq(keywordsArray))
    //   _.uniq(keywordsArray).map(aa => {
    //     finalArray.push({
    //       keyword: aa,
    //       count: tempArray[tempArray.findIndex(x => x.keyword == aa)].count
    //     });
    //   });
    //   this.finalArray = finalArray;
    //   this.negativeMediaKeywordMatchesTotal = keywordMatchesTotal;
    //   this.popoverId = null;
    //   let itemId = data.item.id.toString();
    //   this.popoverId = itemId;
    //   this.$refs.popoverWebsite.$emit("open");
    // },

    // onCloseWebsite() {
    //   this.$refs.popoverWebsite.$emit("close");
    // },

    // onOk() {
    //   if (!this.input1) {
    //     this.input1state = false;
    //   }
    //   if (this.input1) {
    //     this.onClose();
    //     // Return our popover form results
    //     this.input1Return = this.input1;
    //   }
    // },

    // onShow() {
    //   // This is called just before the popover is shown
    //   // Reset our popover form variables
    //   this.input1 = "";
    //   this.input1state = null;
    //   this.input1Return = "";
    // },

    // popOverContent() {
    //   alert("jj");
    //   this.$root.$emit("bv::show::popover", "popover-reactive-1");
    // },

    reloadTable() {
      this.$root.$emit("bv::refresh::table", "my-table");
    },

    async getControlGroupSearchPopulationTableData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
        control_group_search_id: this.$route.params.id,
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP(
        "post",
        "v1/control-group/search-population",
        formData,
        {
          Authorization: token,
        }
      );

      return result
        .then((response) => {
          // console.log(response.data.data);
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch((error) => {
          this.isLoading = false;
          return [];
        });
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

.table-col {
  /* max-height: calc(100vh - 140px); */
  /* overflow-y: scroll; */
}

.pagination {
  margin-top: 0;
}

.btn.btn-border {
  border: 1px solid;
  margin-right: 2px;
}

.vuetable-pagination-info {
  margin-top: 8px !important;
}

span.sort-icon {
  float: right;
  color: #ff9100;
}

.table-responsive-sm {
  /* height: calc(100vh - 140px) !important; */
  /* overflow-y: scroll !important */
}
</style>
